import http from "@/utils/request";

const taxAccountApi = {
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxAccount.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  create: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxAccount.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  createSubAccount: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxSubAccount.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default taxAccountApi;
